import { Immutable } from "immer";
import React, { useEffect, useState } from "react";

import { IProductID } from "../../../models/nominals";
import { useAppSelector } from "../../../store/reducers";
import { rootProductSelector } from "../selectors";

type IProps = Immutable<{
    blockProductID: IProductID;
    isInitiallyVisible: boolean;
    children?: React.ReactNode;
}>;

export const PDPSelectedRootProductConditionalBlock = (
    props: IProps,
): React.ReactNode => {
    const selectedRootProduct = useAppSelector((state) =>
        rootProductSelector(state.configurator),
    );

    // Consumer pattern: use server-provided initial visibility until Redux is populated
    const [hasMounted, setHasMounted] = useState(false);
    useEffect(() => {
        setHasMounted(true);
    }, []);

    const isSelected =
        hasMounted && selectedRootProduct !== null
            ? props.blockProductID === selectedRootProduct.id
            : props.isInitiallyVisible;

    // Build IDs for relationship to tab controls. These IDs must match the IDs used by PDPChangeRootProductBlock.
    const tabControlID = `change-root-product-block-${props.blockProductID}`;
    const tabPanelID = `root-product-conditional-block-${props.blockProductID}`;

    return (
        <div
            id={tabPanelID}
            role="tabpanel"
            aria-labelledby={tabControlID}
            aria-hidden={!isSelected}
            style={{ display: isSelected ? "block" : "none" }}
        >
            {props.children}
        </div>
    );
};
